import { rest } from 'msw'
import mockGuestTestsResponse from './guestTests.response.json'
import mockAvailableDaysResponse from './availableDays.response.json'
import mockAvailabilitiesResponse from './availabilities.response.json'

export const handlers = [
  rest.get('/api/guest_tests', (req, res, ctx) => res(ctx.status(200), ctx.json(mockGuestTestsResponse)),
  ),
  rest.get('/api/available-days/:product/:location',
    (req, res, ctx) => res(ctx.status(200), ctx.json(mockAvailableDaysResponse)),
  ),
  rest.get('/api/availabilities', (req, res, ctx) => res(ctx.status(200), ctx.json(mockAvailabilitiesResponse)),
  ),
]
